// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2KSO9","selected":"Chip_selected__BHb2x"};